import { Veille } from "../../../model/Veille";

const VEILLE_CHANGE = 'VEILLE/CHANGE';

export default function veilleChangeAction (veille: Veille) {
  return {
    type: VEILLE_CHANGE,
    payload: { 
        veille: veille
     }
  };
}

export { VEILLE_CHANGE };